import React from 'react'
import { Link } from 'react-router-dom'
import ApiUrl from '../../../configTools/apiUrl'

const Item = ({Obj}) => {
  return (
    <Link to={'/admin/user/view/'+Obj.username}>
      <div className='form_item_row_container discription'>
        <div className='form_item_row_container_itemfull' style={{width:'10%'}}>
          <div style={{
              backgroundImage:`url(${ApiUrl.API_URL_Image_Thumbnail+Obj.image})`,
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              width: "100%",
              paddingTop: "80%",
              borderRadius: "3px",
              border: "2px solid black",
              position:"relative"
          }}>
          </div>
        </div>
        <div className='form_item_row_container_item' style={{width:'20%'}}>
          <p>{Obj.firstname}</p>
        </div>
        <div className='form_item_row_container_item' style={{width:'20%'}}>
          <p>{Obj.lastname}</p>
        </div>
        <div className='form_item_row_container_item' style={{width:'30%'}}>
          <p>{Obj.username}</p>
        </div>
        <div className='form_item_row_container_item' style={{width:'20%'}}>
          <p>{Obj.role}</p>
        </div>
      </div>
    </Link>
    
  )
}

export default Item
